export class PARTS {
    constructor(
        public PA_ID: number,
        public NAME: string,
        public SHORT_NAME: string,
        public CONTACT_PERS: string,
        public TEL_NO: string,
        public FAX_NO: string,
        public EMAIL_ADDR: string,
        public INTERNET_ADDR: string,
        public REMARK: string,
        public CG_APP: number,
        public CD_APP: string,
        public CG_INST_TYP: number,
        public CD_INST_TYP: string
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/part.ts